import React, { useCallback, useMemo } from 'react'

import Message from './Message'
import { COLORS } from '@btime/constants'
import { useLoggedUser, useSessionPermission } from '@btime/react-session'
import { useNavigation } from '../../utils/contexts/NavigationContext'

const PendingBillingMessage = () => {
  const navigate = useNavigation()
  const loggedUser = useLoggedUser()
  const shouldShow = useSessionPermission('showBillingWarning')

  const handleClick = useCallback(() => {
    if (loggedUser.canAccessPaymentModule) {
      navigate('/finance')
    }
  }, [loggedUser, navigate])

  const message = useMemo(() => {
    if (loggedUser.canAccessPaymentModule) {
      return `**🚨 Há uma fatura em aberto!** Clique aqui e resolva esta pendência o quanto antes para evitar o bloqueio do serviço. ⏳`
    }
    return `**🚨 Há uma fatura em aberto!** Fale com o responsável financeiro e resolva esta pendência o quanto antes para evitar o bloqueio do serviço. ⏳`
  }, [loggedUser.canAccessPaymentModule])

  if (!shouldShow) return <></>

  return (
    <Message
      onClick={handleClick}
      title={message}
      useMarkdown={true}
      color={COLORS.dark3}
      bgColor={COLORS.lightYellow}
    />
  )
}

export default PendingBillingMessage
